import { render } from "./Index.vue?vue&type=template&id=16a81d91"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import exportComponent from "/Users/herianto/Projects/yeu-logistik/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/DonationTypes/Index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "16a81d91"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('16a81d91', __exports__)) {
    console.log('reload')
    api.reload('16a81d91', __exports__)
  }
  
  module.hot.accept("./Index.vue?vue&type=template&id=16a81d91", () => {
    console.log('re-render')
    api.rerender('16a81d91', render)
  })

}


export default __exports__